import { FC, useEffect } from "react"
import { Linking } from "react-native"
import { observer } from "mobx-react-lite"
import { useStores } from "../../models"

export const ImageViewing: FC<any> = observer(function ImageViewing(props) {
  const { images = [], imageIndex, visible, onRequestClose } = props
  const { tokenStore } = useStores()

  useEffect(() => {
    if (visible) {
      Linking.openURL(`${images[imageIndex].uri}?cache_key=${tokenStore.cacheKey}`)
        .catch()
    }
  }, [imageIndex, images, onRequestClose, tokenStore, visible])

  useEffect(() => {
    tokenStore.requestCacheKey()
  }, [tokenStore])

  return null
})
